import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import toExport from "@beeldit/core/services/export";
import { ListActionContext } from "../list/ListActionContext";

function useExport() {
  const { tableFilters: exportFilters, orderBy } = useContext(ListActionContext);
  const errorHandler = useErrorHandler();
  const extension = 'csv';
  return () => {
    let filterPath = `extension=${extension}&entity=users`;
    if (exportFilters) {
      for (const [key, value] of Object.entries(exportFilters)) {
        if (value) {
          filterPath += `&${key}=${value}`;
        }
      }
    }
    if (orderBy) {
      filterPath += `&orderBy=${orderBy}`;
    }
    toExport("users", filterPath)
      .then((response: any) => {
        // Tratar la respuesta como Blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Usuarios.${extension}`);
        document.body.appendChild(link);
        link.click();

        // Limpieza: elimina el link y el URL del objeto
        if (link.parentNode) {
          link.parentNode.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useExport;
